<app-admin-menu></app-admin-menu>
<router-outlet></router-outlet>
